export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/837e258702481769ad64684ae735d0c9.svg";